
export const VIEWS = {
  HOME: 'home',
  CONTACT: 'contact',
  FORGOT_PASSWORD: 'forgot-password',
  SIGNUP: 'signup',
  VERIFY_OTP: 'verify-otp',
  USER_INFO: 'user-info',
  EDIT_PROFILE: 'edit-profile',
  SELFIE: 'selfie',
  SCORES: 'scores',
  RECOMMENDATIONS: 'recommendations',
  FEEDBACK: 'feedback',
  ERROR: 'error',
  WELCOME: 'Welcome',
  USER_DETAILS: 'UserDetails',
  MORE_USER_DETAILS: 'MoreUserDetails',
  DISTRIBUTOR_LOGIN: 'distributor-login',
  DISTRIBUTOR_WELCOME: 'distributor-welcome',
  DISTRIBUTOR_CODE_HANDLER: 'distributor-code-handler',
  DISTRIBUTOR_SUCCESSFUL: 'distributor-successful',
  DISTRIBUTOR_USER_DETAILS: 'DistributorUserDetails',
  DISTRIBUTOR_DEACTIVATED_USER: 'DistributorDeactivatedUser',
  PRIVACY_POLICY: 'privacy-policy',
} as const;
